import { fmtPct } from "../../ui";

/**
 * A percentage that also shows its bar: the figure on top, the track under it.
 *
 * Shared by the list column and the roadmap card so the same number is the same
 * width and the same weight in both views - a bar alone cannot be compared
 * across rows any better than a colour can.
 */
export function Progress({ pct }: { pct: number }) {
  const clamped = Math.min(100, Math.max(0, pct));
  return (
    <span>
      <span className="crm-rate-v">{fmtPct(clamped, 0)}</span>
      <span className="crm-rate-b">
        <i
          style={{
            width: `${clamped}%`,
            background: "linear-gradient(90deg, var(--color-primary), var(--color-primary-2))",
          }}
        />
      </span>
    </span>
  );
}
